/**
 * @generated SignedSource<<377cb8de558ff9466d580d3c88c20742>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FeedbackQuery$variables = {};
export type FeedbackQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly hasAccessTo360Feedback: boolean;
        readonly hasAccessToFeedback: boolean;
      };
    };
    readonly feedbackActionsAmount: number;
    readonly feedbackUnreadItemsCount: number;
    readonly unreadBeacons: ReadonlyArray<string>;
  };
};
export type FeedbackQuery = {
  response: FeedbackQuery$data;
  variables: FeedbackQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "hasAccessToFeedback",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "feedback"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"feedback\")"
},
v1 = {
  "alias": "hasAccessTo360Feedback",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "three_sixty_feedback"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"three_sixty_feedback\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadBeacons",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feedbackActionsAmount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feedbackUnreadItemsCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedbackQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FeedbackQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d618f459a2adc16f4c641351e6e38784",
    "id": null,
    "metadata": {},
    "name": "FeedbackQuery",
    "operationKind": "query",
    "text": "query FeedbackQuery {\n  viewer {\n    account {\n      billingAccount {\n        hasAccessToFeedback: hasAccessToFeature(feature: feedback)\n        hasAccessTo360Feedback: hasAccessToFeature(feature: three_sixty_feedback)\n        id\n      }\n      id\n    }\n    unreadBeacons\n    feedbackActionsAmount\n    feedbackUnreadItemsCount\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "cb0573c6e94bae4313885a1ed1c2140e";

export default node;
